import styled from "styled-components";

export const StyledConfirmationText = styled.span`
    display: inline-flex;
    align-items: center;

    & b {
        vertical-align: middle;

        & span {
            display: inline-block;
            overflow: hidden;
            max-width: 240px;
            text-overflow: ellipsis;
            vertical-align: middle;
            white-space: nowrap;
        }
    }
`;
